import { IApiService } from './IApiService';
import Turnus from 'src/models/Turnus';
import Den from 'src/models/Den';
import Klient from 'src/models/Klient';
import Objednavka from 'src/models/Objednavka';
import 'whatwg-fetch';
import { MealToMakeReport } from 'src/models/reports/MealToMakeReport';
import AuthStore from 'src/stores/AuthStore';
import moment from 'moment';
import NewOrderResponse from './response/NewOrderResponse';
import CalculateOrderResponse from './response/CalculateOrderResponse';
import PreparePaymentDetailsResponse from './response/PreparePaymentDetailsResponse';
import SendPaymentDetailsResponse from './response/SendPaymentDetailsResponse';
import Sleva from 'src/models/Sleva';
import { string } from 'prop-types';
import Historie from 'src/models/Historie';
import FakturacniSubjekt from 'src/models/FakturacniSubjekt';
import Faktura from 'src/models/Faktura';
import Trasa from 'src/models/Trasa';
import Rozvoz from 'src/models/Rozvoz';
import Cenik from 'src/models/Cenik';
import WebObjednavka from 'src/models/WebObjednavka';
import {Config} from 'src/Config';
import FakturaceNahled from "../models/FakturaceNahled";

export default class RESTApiService implements IApiService {

    private authStore: AuthStore;
    private baseURL: string = Config.baseURL;
    private baseURLTest: string = "https://krabicky-test.unknown.cz/rest";
    private baseURLProd: string = "https://unknown.cz/lucka/rest";

    constructor(authStore: AuthStore) {
        this.authStore = authStore;
    }

    public getObjednavky(): Promise<Objednavka[]> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/objednavka?token=' + this.authStore.token)
              .then(this.handleErrors)
              .then(resp => {
                resp.json().then(json => {
                  const retVal: Objednavka[] = []; 
                  json.forEach(it => {
                    const obj = new Objednavka();
                    obj.loadFromJSON(it);
                    retVal.push(obj);
                  });
                  resolve(retVal);
                });
              })
              .catch(this.reportError(reject));
        });
    }
    public getKlients(): Promise<Klient[]> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/klient?token=' + this.authStore.token)
              .then(this.handleErrors)
              .then(resp => {resolve(resp.json())})
              .catch(this.reportError(reject));
        })
    }
    public getKlientTurnus(klientId: number): Promise<Turnus[]> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/klient/' + klientId +'/turnusy?token=' + this.authStore.token)
              .then(this.handleErrors)
              .then(resp => {
                resp.json().then(json => {
                  const retVal: Turnus[] = [];
                  json.forEach(item => {
                    const turnus = new Turnus();
                    turnus.loadFromJSON(item);
                    retVal.push(turnus);
                  });
                  resolve(retVal);
                });
              })
              .catch(this.reportError(reject));
        });
    }
    public getKlientDen(klientId: number): Promise<Den[]> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/klient/' + klientId +'/dny?token=' + this.authStore.token)
              .then(this.handleErrors)
              .then(resp => {
                resp.json().then(json => {
                  json.forEach(item => {
                    item.idKlient = item.id_klient;
                    item.datum = new Date(item.datum);
                  });
                  resolve(json);
                });
              })
              .catch(this.reportError(reject));
        });
    }
    public createNewTurnus(turnus: Turnus): Promise<Turnus> {
        const toInsert = {
          id_klient: turnus.idKlient,
          od: this.formatDate(turnus.od),
          do: this.formatDate(turnus.do),
          program: turnus.program,
          id_objednavka: turnus.idObjednavka
        };

        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/turnus?token=' + this.authStore.token, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(toInsert)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                turnus.id = json.last_id;
                resolve(turnus);
              });
            })
            .catch(this.reportError(reject));
        });
    }
    public createNewKlient(klient: Klient): Promise<Klient> {
        const toInsert = {
          jmeno: klient.jmeno,
          prijmeni: klient.prijmeni,
          telefon: klient.telefon,
          email: klient.email,
          ulice: klient.ulice,
          mesto: klient.mesto,
          PSC: klient.PSC
        };

        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/klient?token=' + this.authStore.token, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(toInsert)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                klient.id = json.last_id;
                resolve(klient);
              });
            })
            .catch(this.reportError(reject));
        });
    }

    public updateKlient(klient: Klient): Promise<Klient> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/klient/' + klient.id + '?token=' + this.authStore.token, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(klient)})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(klient);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public deleteKlient(klient: Klient): Promise<Klient> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/klient/' + klient.id + '?token=' + this.authStore.token, {method: 'DELETE'})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(klient);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public updateTurnus(turnus: Turnus): Promise<Turnus> {
      // Hnusny hack kvuli prevodu na UTC pri volani stringify
      const backup = Date.prototype.toJSON;
      Date.prototype.toJSON = function() {return moment(this).format();}
      const JSONBody: string = JSON.stringify(turnus);
      Date.prototype.toJSON = backup;
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/turnus/' + turnus.id + '?token=' + this.authStore.token, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSONBody})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(turnus);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public deleteTurnus(turnus: Turnus): Promise<Turnus> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/turnus/' + turnus.id + '?token=' + this.authStore.token, {method: 'DELETE'})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(turnus);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public createNewDen(den: Den): Promise<Den> {
        const toInsert = {
          id_klient: den.idKlient,
          datum: this.formatDate(den.datum),
          typ: den.typ,
          program: den.program
        };

        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/den?token=' + this.authStore.token, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(toInsert)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                resolve(den);
              });
            })
            .catch(this.reportError(reject));
        });
    }

    public deleteDen(den: Den): Promise<Den> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/den/' + den.idKlient + '/' + this.formatDate(den.datum) + '?token=' + this.authStore.token, {method: 'DELETE'})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(den);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getMealsToMakeReport(date: Date): Promise<MealToMakeReport[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/report/mealsToMake/' + this.formatDate(date) + '?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: MealToMakeReport[] = [];
              json.forEach(item => {
                const itemConv: MealToMakeReport = new MealToMakeReport();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getTurnusyAll(): Promise<Turnus[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/turnus?token=' + this.authStore.token)
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                const retVal: Turnus[] = [];
                json.forEach(item => {
                  const turnus = new Turnus();
                  turnus.loadFromJSON(item);
                  retVal.push(turnus);
                });
                resolve(retVal);
              });
            })
            .catch(this.reportError(reject));
      })
    }

    private prepareNewOrderData(turnusyData: Map<number, Turnus[]>, dnyData: Map<number, Den[]>,
                                slevy: Map<number, string>, eko: Map<number, boolean>,
                                nekompletni: Map<number, boolean>, castecneMenu: Map<number, boolean>, webOrder: number): string {
        const toInsert = {};
        toInsert['turnusy'] = {};
        toInsert['dny'] = {};
        toInsert['slevy'] = {};
        toInsert['modifikatory'] = {};

        if(webOrder != null) {
            toInsert['webOrder'] = webOrder;
        }

        turnusyData.forEach((turnusy:Turnus[], key) => {
            toInsert['turnusy'][key] = [];
            turnusy.forEach((val:Turnus) => {
                toInsert['turnusy'][key].push({
                    id_klient: val.idKlient,
                    od: val.od,
                    do: val.do,
                    program: val.program,
                    rozsah: val.rozsah
                });
            })
        });

        dnyData.forEach((dny:Den[], key) => {
            toInsert['dny'][key] = [];
            dny.forEach((val:Den) => {
                toInsert['dny'][key].push({
                    id_klient: val.idKlient,
                    datum: val.datum,
                    typ: val.typ,
                    program: val.program,
                    rozsah: val.rozsah
                });
            });
        });

        slevy.forEach((sleva:string, key:number) => {
            toInsert['modifikatory'][key] = [];
            toInsert['modifikatory'][key].push({
                typ: 'sleva',
                hodnota: sleva
            });
        });

        eko.forEach((ekoState:boolean, key:number) => {
            if(toInsert['modifikatory'][key] === undefined) {
                toInsert['modifikatory'][key] = [];
            }
            if(ekoState) {
                toInsert['modifikatory'][key].push({
                    typ: 'eko',
                });
            }
        });

        nekompletni.forEach((nekoState:boolean, key:number) => {
            if(toInsert['modifikatory'][key] === undefined) {
                toInsert['modifikatory'][key] = [];
            }
            if(nekoState) {
                toInsert['modifikatory'][key].push({
                    typ: 'nekompletni',
                });
            }
        });

        castecneMenu.forEach((castMenuState:boolean, key:number) => {
            if(toInsert['modifikatory'][key] === undefined) {
                toInsert['modifikatory'][key] = [];
            }
            if(castMenuState) {
                toInsert['modifikatory'][key].push({
                    typ: 'castecne_menu',
                });
            }
        });

        const backup = Date.prototype.toJSON;
        Date.prototype.toJSON = function() {return moment(this).format();}
        const JSONBody: string = JSON.stringify(toInsert);
        Date.prototype.toJSON = backup;
        return JSONBody;
    }

    public calculateNewOrderFull(turnusyData: Map<number, Turnus[]>, dnyData: Map<number, Den[]>,
                          slevy: Map<number, string>, eko: Map<number, boolean>,
                          nekompletni: Map<number, boolean>, castecneMenu: Map<number, boolean>, webOrder: number): Promise<PreparePaymentDetailsResponse> {
        const JSONBody = this.prepareNewOrderData(turnusyData, dnyData, slevy, eko, nekompletni, castecneMenu, webOrder);
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/objednavka/calculateNewOrderFull?token=' + this.authStore.token, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSONBody})
                .then(this.handleErrors)
                .then(resp => {
                    resp.json().then(json => {
                        const retVal: PreparePaymentDetailsResponse = new PreparePaymentDetailsResponse();
                        retVal.emailText = json['emailText'];
                        retVal.totalPrice = json['totalPrice'];
                        resolve(retVal);
                    });
                })
                .catch(this.reportError(reject));
        });
    }

    public deleteOrder(orderID: number):Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/objednavka/' + orderID + '?token=' + this.authStore.token, {method: 'DELETE'})
                .then(this.handleErrors)
                .then(resp => {
                    resp.json().then(json => {
                        resolve(true);
                    });
                })
                .catch(this.reportError(reject));
        });
    }

    public createNewOrder(turnusyData: Map<number, Turnus[]>, dnyData: Map<number, Den[]>, 
                          slevy: Map<number, string>, eko: Map<number, boolean>, 
                          nekompletni: Map<number, boolean>, castecneMenu: Map<number, boolean>, webOrder: number): Promise<NewOrderResponse> {
      const JSONBody = this.prepareNewOrderData(turnusyData, dnyData, slevy, eko, nekompletni, castecneMenu, webOrder);
        console.log("api.createNewOrder: Creating promise");
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka?token=' + this.authStore.token, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSONBody})
          .then(this.handleErrors)
          .then(resp => {
              console.log("api.createNewOrder: successfull response");
            resp.json().then(json => {
                console.log("api.createNewOrder: parsing JSON");
              const retVal = new NewOrderResponse();
              retVal.id = json['last_id'];
              retVal.objednavka = new Objednavka();
              retVal.objednavka.loadFromJSON(json.objednavka);
              json['turnusy'].forEach(trns => {
                const turnus = new Turnus();
                turnus.loadFromJSON(trns);
                retVal.turnusy.push(turnus);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public updateOrder(objednavka: Objednavka): Promise<Objednavka> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/' + objednavka.id + '?token=' + this.authStore.token, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(objednavka)})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(objednavka);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public preparePaymentDetails(orderId: number): Promise<PreparePaymentDetailsResponse> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/' + orderId + '/preparePaymentDetails?token=' + this.authStore.token)
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                const retVal: PreparePaymentDetailsResponse = new PreparePaymentDetailsResponse();
                retVal.emailText = json['emailText'];
                retVal.totalPrice = json['totalPrice'];
                resolve(retVal);
              });
            })
            .catch(this.reportError(reject));
      })
    }

    public sendPaymentDetails(orderId: number, address: string, text: string): Promise<SendPaymentDetailsResponse> {
      const body = {};
      body['address'] = address;
      body['text'] = text;
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/' + orderId + '/sendPaymentDetails?token=' + this.authStore.token,
            {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                const retVal: SendPaymentDetailsResponse = new SendPaymentDetailsResponse();
                retVal.response = json['result'];
                resolve(retVal);
              });
            })
            .catch(err => reject(err));
      })
      
    }

    public calculateNewOrder(turnusyData: Map<number, Turnus[]>, dnyData: Map<number, Den[]>): Promise<CalculateOrderResponse[]> {
      const toInsert = {};
      toInsert['turnusy'] = {};
      toInsert['dny'] = {};

      turnusyData.forEach((turnusy:Turnus[], key) => {
        toInsert['turnusy'][key] = [];
        turnusy.forEach((val:Turnus) => {
          toInsert['turnusy'][key].push({
            id_klient: val.idKlient,
            od: val.od,
            do: val.do,
            program: val.program,
            rozsah: val.rozsah
          });
        })
      });

      dnyData.forEach((dny:Den[], key) => {
        toInsert['dny'][key] = [];
        dny.forEach((val:Den) => {
          toInsert['dny'][key].push({
            id_klient: val.idKlient,
            datum: val.datum,
            typ: val.typ,
            program: val.program
          });
        });
      });

      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/calculateNewOrder?token=' + this.authStore.token, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(toInsert)})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: CalculateOrderResponse[] = [];
              json.forEach(client => {
                const clientResult: CalculateOrderResponse = new CalculateOrderResponse();
                clientResult.clientId = client['klient_id'];
                if(client['discount'] != null) {
                  clientResult.discount = new Sleva();
                  clientResult.discount.loadFromJSON(client['discount']);
                }
                clientResult.partialMenu = client.castecne_menu;
                retVal.push(clientResult);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getCiselnikSleva(): Promise<Sleva[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/ciselnik/sleva?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Sleva[] = [];
              json.forEach(item => {
                const itemConv: Sleva = new Sleva();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getCiselnikTrasa(): Promise<Trasa[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/ciselnik/trasa?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Trasa[] = [];
              json.forEach(item => {
                const itemConv: Trasa = new Trasa();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getCiselnikCenik(): Promise<Cenik[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/ciselnik/cenik?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Cenik[] = [];
              json.forEach(item => {
                const itemConv: Cenik = new Cenik();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getOrderHistory(orderId: number): Promise<Historie[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/' + orderId + '/history?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Historie[] = [];
              json.forEach(item => {
                const itemConv: Historie = new Historie();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getClientHistory(clientId: number): Promise<Historie[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/klient/' + clientId + '/history?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Historie[] = [];
              json.forEach(item => {
                const itemConv: Historie = new Historie();
                itemConv.loadFromJSON(item);
                retVal.push(itemConv);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getFakturacniSubjektyAll(): Promise<FakturacniSubjekt[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/fakturace/subjekt?token=' + this.authStore.token)
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                const retVal: FakturacniSubjekt[] = [];
                json.forEach(item => {
                  const subjekt = new FakturacniSubjekt();
                  subjekt.loadFromJSON(item);
                  retVal.push(subjekt);
                });
                resolve(retVal);
              });
            })
            .catch(this.reportError(reject));
      })
    };

    public getAvailableSubjects(): Promise<FakturacniSubjekt[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/fakturace/availableSubjects?token=' + this.authStore.token)
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                const retVal: FakturacniSubjekt[] = [];
                json.forEach(item => {
                  const subjekt = new FakturacniSubjekt();
                  subjekt.loadFromJSON(item);
                  retVal.push(subjekt);
                });
                resolve(retVal);
              });
            })
            .catch(this.reportError(reject));
      })
    };

    public addFakturacniSubjekt(subjekt: FakturacniSubjekt): Promise<FakturacniSubjekt> {
        const toInsert = {
          id_klient: subjekt.idKlient,
          id_subject: subjekt.idSubjekt,
          name: subjekt.name,
          relation_type: subjekt.relationType
        };

        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/fakturace/subjekt?token=' + this.authStore.token, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(toInsert)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                subjekt.id = json['last_id'];
                resolve(subjekt);
              });
            })
            .catch(this.reportError(reject));
        });
    }

    public removeFakturacniSubjekt(subjekt: FakturacniSubjekt): Promise<boolean> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/fakturace/subjekt/'+ subjekt.id +'?token=' + this.authStore.token, {
          method: 'DELETE'
        })
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(true);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public createNewInvoice(faktura: Faktura): Promise<Faktura> {
        const toInsert = {
          id_objednavka: faktura.idObjednavka,
          id_subject: faktura.idSubjekt,
          price: faktura.price
        };

        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/fakturace/invoice?token=' + this.authStore.token, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(toInsert)})
            .then(this.handleErrors)
            .then(resp => {
              resp.json().then(json => {
                faktura.id = json.id;
                faktura.idFaktura = json.id_faktura;
                resolve(faktura);
              });
            })
            .catch(this.reportError(reject));
        });
    }

    public getFakturyByOrderID(orderID: number): Promise<Faktura[]> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/objednavka/' + orderID + '/invoices?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Faktura[] = [];
              json.forEach(item => {
                const faktura = new Faktura();
                faktura.loadFromJSON(item);
                retVal.push(faktura);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getFakturaNahledByOrderID(orderID: number): Promise<FakturaceNahled> {
        return new Promise<FakturaceNahled>((resolve, reject) => {
            this.internalFetch(this.baseURL + '/fakturace/invoicePreview/' + orderID + '?token=' + this.authStore.token)
                .then(this.handleErrors)
                .then(resp => {
                    resp.json().then(json => {
                        const nahled: FakturaceNahled = new FakturaceNahled();
                        nahled.loadFromJSON(json);
                        resolve(nahled);
                    })
                })
        })
    }

    public getRozvozByDate(from: Date, to: Date): Promise<Rozvoz[]> {
      return new Promise((resolve, reject) => {
        const fromString = moment(from).format('YYYY-MM-DD');
        const toString = moment(to).format('YYYY-MM-DD');
          this.internalFetch(this.baseURL + '/rozvoz/' + fromString + '/' + toString + '?token=' + this.authStore.token)
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              const retVal: Rozvoz[] = [];
              json.forEach(item => {
                const rozvoz = new Rozvoz();
                rozvoz.loadFromJSON(item);
                retVal.push(rozvoz);
              });
              resolve(retVal);
            });
          })
          .catch(this.reportError(reject));
      });

    }

    public getWebObjednavky(): Promise<WebObjednavka[]> {
        return new Promise((resolve, reject) => {
            this.internalFetch(this.baseURL + '/web-order?token=' + this.authStore.token)
              .then(this.handleErrors)
              .then(resp => {
                resp.json().then(json => {
                  const retVal: WebObjednavka[] = []; 
                  json.forEach(it => {
                    const obj = new WebObjednavka();
                    obj.loadFromJSON(it);
                    retVal.push(obj);
                  });
                  resolve(retVal);
                });
              })
              .catch(this.reportError(reject));
        });
    }

    public markWebOrderProcessed(id: number): Promise<boolean> {
      return new Promise((resolve, reject) => {
          this.internalFetch(this.baseURL + '/web-order/' + id + '?token=' + this.authStore.token,  {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: '{"placeholder":1}'})
          .then(this.handleErrors)
          .then(resp => {
            resp.json().then(json => {
              resolve(true);
            });
          })
          .catch(this.reportError(reject));
      });
    }

    public getNewEmailsCount(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
            this.internalFetch(this.baseURL + '/report/smartEmailing/count' + '?token=' + this.authStore.token)
                .then(this.handleErrors)
                .then(res => {
                    res.json().then(json => {
                        resolve(json.count);
                    });
                })
                .catch(this.reportError(reject));
        });
    }

    private internalFetch(input: Request | string, init?: RequestInit) {
        let url = input instanceof Request ? input.url : input;
        if(url !== null && url !== undefined) {
            url = url.split("?")[0];
        }
        const method = init !== null && init !== undefined ? init.method : "GET";
        console.log("Request: " + method + ": " + url);
        return fetch(input, init);
    }

    public getRestUrl(url: string): string {
      return this.baseURL + url + '?token=' + this.authStore.token;
    }

    private formatDate(date: Date): string {
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }

    private handleErrors(response) {
        let url = response.url;
        if(url !== null && url !== undefined) {
            url = url.split("?")[0];
        }
        console.log(response.status + "-" + response.statusText + " on: " + url);
      if(!response.ok) {
        throw Error(response.statusText);
      }
      return response;
    }

    private reportError = reject => error => {
      alert("Bohužel došlo k chybě, kontaktujte prosím někoho kdo to vyřeší.");
      reject();
    }

}



// WEBPACK FOOTER //
// ./src/services/RESTApiService.tsx